module.exports = __webpack_public_path__ + "static/media/virtualmin.aa07da08.svg";